import Vue from "vue";
import Router from "vue-router";

import Home from "@/views/Home.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "Solidaridad por las familias - Refacil",
        layout: "default"
      }
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js